/* eslint-disable no-lonely-if */
/* eslint-disable react/no-array-index-key */
/* eslint no-underscore-dangle: ["error", { "allow": [ "_id"] }] */

import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import {
  Card,
  CardContent,
  CardActions,
  CardHeader,
  Typography,
  Button,
  CircularProgress,
  Grid,
  TextField,
  Alert
} from '@mui/material';
// import { ExpandMore } from '@mui/icons-material';
import { Formik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import SettingAction from '../../store/actions/SettingAction';
import { ValidateProfile } from '../../assets/validation';

export default function UserProfile() {
  const [data, setData] = useState([]);
  // const [modeValue, setModeValue] = useState('');

  const dispatch = useDispatch();
  const { profileData } = useSelector((state) => state.setting); // Replace 'data' with your reducer name

  useEffect(() => {
    dispatch(SettingAction.getUserProfile());
  }, [dispatch]);

  useEffect(() => {
    if (profileData && profileData?.data) {
      setData(profileData.data);
    }
  }, [profileData]);

  const getDirtyValues = (values, initialObject) => {
    const newdata = { ...values };
    const keyValues = Object.keys(newdata);

    const dirtyValues = keyValues.filter(
      (keyValue) => newdata[keyValue] !== initialObject[keyValue]
    );

    keyValues.forEach((key) => {
      if (!dirtyValues.includes(key)) delete newdata[key];
    });
    return newdata;
  };

  const initialValues = {
    name: data?.name ?? '',
    email: data?.email ?? ''
  };

  return (
    <Box sx={{ mb: 3 }} className="cardWrapper">
      <div className="pageTitleWrap">
        <Typography className="" component="h2" variant="h2">
          Profile
        </Typography>
      </div>
      <Formik
        initialValues={initialValues}
        enableReinitialize
        validationSchema={ValidateProfile}
        onSubmit={(values, { setErrors, setSubmitting }) => {
          const updateValues = getDirtyValues(values, initialValues);
          dispatch(SettingAction.updateUserProfile(updateValues, setErrors, setSubmitting));
        }}
      >
        {({
          errors,
          touched,
          values,
          handleChange,
          handleBlur,
          handleSubmit,
          handleReset,
          isSubmitting,
          setFieldValue
        }) => (
          <form onSubmit={handleSubmit}>
            <Card>
              <CardHeader sx={{ textAlign: 'left !important' }} title="Name" />
              <CardContent>
                <Grid container columnSpacing={2} rowSpacing={0} alignItems="stretch">
                  <Grid item lg={4} xl={4}>
                    <TextField
                      error={errors.name && touched.name}
                      label="Name"
                      className=""
                      fullWidth
                      type="text"
                      name="name"
                      value={values.name}
                      // maxRows={4}
                      placeholder="Enter Name"
                      onChange={(e) => {
                        setFieldValue('name', e.target.value);
                        handleChange(e);
                      }}
                      onBlur={handleBlur}
                      helperText={errors.name && touched.name && errors.name}
                      margin="normal"
                      variant="outlined"
                      required={false}
                      InputLabelProps={{ required: true }}
                    />
                  </Grid>
                  <Grid item lg={4} xl={4}>
                    <TextField
                      error={errors.email && touched.email}
                      label="Email"
                      className=""
                      fullWidth
                      type="email"
                      name="email"
                      value={values.email}
                      // maxRows={4}
                      placeholder="Enter Email"
                      onChange={(e) => {
                        setFieldValue('email', e.target.value);
                        handleChange(e);
                      }}
                      onBlur={handleBlur}
                      helperText={errors.email && touched.email && errors.email}
                      margin="normal"
                      variant="outlined"
                      required={false}
                      InputLabelProps={{ required: true }}
                    />
                  </Grid>
                </Grid>
                {data && data?.message ? (
                  <Alert variant="filled" sx={{ mt: 2 }} severity="info">
                    <Typography
                      sx={{ my: '0px!important' }}
                      component="p"
                      variant="body1"
                      dangerouslySetInnerHTML={{ __html: data?.message }}
                    />
                  </Alert>
                ) : (
                  ''
                )}
              </CardContent>
              <CardActions
                sx={{
                  backgroundColor: 'rgba(0, 0, 0, 0.06)',
                  p: 2,
                  justifyContent: 'center'
                }}
              >
                <Button
                  type="submit"
                  className="save__btn"
                  variant="contained"
                  color="secondary"
                  // fullWidth
                  disabled={isSubmitting}
                  size="medium"
                >
                  {isSubmitting ? <CircularProgress size={20} /> : 'Submit'}
                </Button>
                <Button
                  type="button"
                  className="cancel__btn"
                  variant="contained"
                  color="info"
                  size="medium"
                  onClick={() => {
                    handleReset();
                  }}
                >
                  Clear
                </Button>
              </CardActions>
            </Card>
          </form>
        )}
      </Formik>
    </Box>
  );
}
